<template>
  <div class="search-container" ref="search">
    <el-form :inline="true" :size="size">
      <div id="searchMain">
        <el-row :gutter="10" id="searchRow">
          <template v-for="(item, index) in searchParams">
            <el-col v-if="isStr(item.type)" :span="4" class="searchCol">
              <el-form-item label="">
                <el-input v-model.trim="query[item.field]" :placeholder="item.label" clearable/>
              </el-form-item>
            </el-col>
            <el-col v-if="isSel(item.type)" :span="4" class="searchCol">
              <el-form-item label="">
                <el-select v-model="query[item.field]" :placeholder="item.label" class="w100" clearable @change="changeSelect(item.label)"
                           :collapse-tags="item.collapse ? true: false"
                           :multiple="item.multiple ? true: false"
                           :filterable="item.filterable ? true: false"
                    >
                  <el-option v-for="(o, index) in item.options" :key="index" :label="o.name" :value="o.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="isDate(item.type)" :span="4" class="searchCol">
              <el-form-item label="">
                <el-date-picker v-model="query[item.field]" :type="item.type"
                                :picker-options="item.pickerOptions ? pickerOptions : {}"
                                :value-format="item.format ? item.format : 'yyyy-MM-dd'"
                                :placeholder="item.label" class="w100" clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col v-if="isDateTime(item.type)" :span="4" class="searchCol">
              <el-form-item label="">
                <el-date-picker v-model="query[item.field]" :type="item.type"
                                :picker-options="item.pickerOptions ? pickerOptions : {}"
                                :value-format="item.format ? item.format : 'yyyy-MM-dd HH:mm:ss'"
                                :placeholder="item.label" class="w100" clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col v-if="isStartDate(item.type)" :span="4" class="searchCol">
              <!--时间区间选择-开始时间-->
              <el-form-item label="">
                <el-date-picker v-model="query[item.field]" type="date"
                                :picker-options="item.computedKey ? computedStartTime(query[item.computedKey]) : {}"
                                value-format="yyyy-MM-dd" :placeholder="item.label" class="w100" clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col v-if="isEndDate(item.type)" :span="4" class="searchCol">
              <!--时间区间选择-结束时间-->
              <el-form-item label="">
                <el-date-picker v-model="query[item.field]" type="date"
                                :picker-options="item.computedKey ? computedEndTime(query[item.computedKey]) : {}"
                                value-format="yyyy-MM-dd" :placeholder="item.label" class="w100" clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col v-if="isRadio(item.type)" :span="4" class="searchCol">
              <el-form-item label="">
                <el-radio-group v-model="query[item.field]" clearable>
                  <el-radio v-for="(o,index) in item.options" :label="o.value" :key="index">{{ o.name }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col v-if="isCascader(item.type)" :span="4" class="searchCol">
              <el-form-item label="">
                <el-cascader
                  :collapse-tags="item.collapse ? true : false"
                  class="w100"
                  v-model="query[item.field]"
                  :options="item.options"
                  :props="item.props"
                  :placeholder="item.label"
                  clearable></el-cascader>
              </el-form-item>
            </el-col>

            <!--          <el-form-item v-if="isStr(item.type)" label="">
                        <el-input v-model="query[item.field]" :placeholder="item.label"/>
                        &lt;!&ndash;          &lt;!&ndash;去掉搜索条件特殊字符处理&ndash;&gt;
                                  <el-input
                                    v-model="query[item.field]"
                                    @input="(e) => (query[item.field] = handleFilterSpecialChar(e))"
                                    :placeholder="item.label"
                                  ></el-input>&ndash;&gt;
                      </el-form-item>
                      <el-form-item v-if="isSel(item.type)" label="">
                        <el-select v-model="query[item.field]" :placeholder="item.label">
                          <el-option v-for="(o, index) in item.options" :key="index" :label="o.name" :value="o.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item v-if="isDate(item.type)" label="">
                        <el-date-picker v-model="query[item.field]" :type="item.type"
                                        :picker-options="item.pickerOptions ? pickerOptions : {}"
                                        :value-format="item.format ? item.format : 'yyyy-MM-dd'"
                                        :placeholder="item.label"
                        >
                        </el-date-picker>
                      </el-form-item>
                      &lt;!&ndash;时间区间选择-开始时间&ndash;&gt;
                      <el-form-item v-if="isStartDate(item.type)" label="">
                        <el-date-picker v-model="query[item.field]" type="date"
                                        :picker-options="item.computedKey ? computedStartTime(query[item.computedKey]) : {}"
                                        value-format="yyyy-MM-dd" :placeholder="item.label"
                        >
                        </el-date-picker>
                      </el-form-item>
                      &lt;!&ndash;时间区间选择-结束时间&ndash;&gt;
                      <el-form-item v-if="isEndDate(item.type)" label="">
                        <el-date-picker v-model="query[item.field]" type="date"
                                        :picker-options="item.computedKey ? computedEndTime(query[item.computedKey]) : {}"
                                        value-format="yyyy-MM-dd" :placeholder="item.label"
                        >
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item v-if="isRadio(item.type)" label="">
                        <el-radio-group v-model="query[item.field]">
                          <el-radio v-for="o in item.options" :label="o.value">{{ o.name }}</el-radio>
                        </el-radio-group>
                      </el-form-item>-->
          </template>
          <el-col :span="6" style="text-align: left;">
            <el-form-item>
              <el-button @click="search" type="primary" icon="el-icon-search">{{ searchBtnName }}</el-button>
              <el-button @click="reset" v-if="isShowReset">重置</el-button>
              <el-button v-show="collapsible" size="mini" plain circle :icon="fold ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" @click="shiftCollapsible"/>
              <slot></slot>
            </el-form-item>
          </el-col>
        </el-row>

<!--        <div v-if="fold" style="display: flex;justify-content: center;align-items: center;margin-bottom: 10px">
          <el-button @click="search" type="primary" icon="el-icon-search" size="mini">{{ searchBtnName }}</el-button>
          <el-button @click="reset" v-if="isShowReset" size="mini">重置</el-button>
        </div>-->

<!--        <div class="expandAllSearch">
&lt;!&ndash;          <el-button @click="search" type="primary" icon="el-icon-search" size="mini">{{ searchBtnName }}</el-button>
          <el-button @click="reset" v-if="isShowReset" size="mini">重置</el-button>
          <el-button type="warning" plain @click="shiftCollapsible"
                     :icon="fold ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                     size="mini"
          >{{ fold ? '收起' : '展开' }}
          </el-button>&ndash;&gt;
          <div>
            <el-button @click="shiftCollapsible" type="text" size="mini" :icon="fold ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
              {{ fold ? '收起' : '展开' }} <i class="el-icon-d-arrow-right"></i></el-button>
          </div>
          &lt;!&ndash;<div >&ndash;&gt;
          &lt;!&ndash;  <i @click="shiftCollapsible" :class="fold ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"></i>&ndash;&gt;
          &lt;!&ndash;</div>&ndash;&gt;
        </div>-->

<!--        <el-row>
          <el-button @click="search" type="primary" icon="el-icon-search" size="mini">{{ searchBtnName }}</el-button>
          <el-button @click="reset" v-if="isShowReset" size="mini">重置</el-button>
          <el-button type="warning" plain @click="shiftCollapsible"
                     :icon="fold ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                     size="mini"
          >{{ fold ? '收起' : '展开' }}
          </el-button>
        </el-row>-->



      </div>
    </el-form>
  </div>
</template>

<script>
  import { getObject } from '@/utils'

  export default {
    name: 'JrSearch',
    props: {
      size: {
        type: String,
        default: 'mini'
      },
      searchBtnName: {
        type: String,
        default: '搜索'
      },
      // 是否显示重置按钮
      isShowReset: {
        type: Boolean,
        default: true
      },
      params: {
        default: () => []
      },
      // 最大展示数，默认5个，超过则隐藏，为0时不限制
      maxShow: {
        type: Number,
        default: 5
      }
    },
    data() {
      return {
        query: null,
        pickerOptions: {
          disabledDate: function (time) {
            return time.getTime() > Date.now() - 8.64e6 //如果不包括今天。就是return time.getTime() > Date.now() - 24*3600*1000;
          }
        },
        collapsible: false,
        fold: false
      }
    },
    computed: {
      // 对父组件传过来的搜索条件进行过滤，去掉不需要展示（隐藏）的条件
      searchParams() {
        return this.params.filter(item => !item.hidden)
      }
    },
    created() {
      this.query = this.initQuery()
    },
    mounted() {
      if (this.maxShow > 0) {
        this.searchItemCtrl()
      }
    },
    methods: {
      // 折叠搜索选项控制
      shiftCollapsible() {
        this.fold = !this.fold
        this.searchItemCtrl()
      },

      // 搜索选项显隐控制
      searchItemCtrl() {
        // const group = window.document.querySelectorAll(`#searchMain .el-form-item.el-form-item--${this.size}`)
        // const group = window.document.querySelectorAll(`#searchMain #searchRow .el-col.searchCol`)
        const group = this.$refs.search.querySelectorAll(`#searchMain #searchRow .el-col.searchCol`)
        let len = group.length ? group.length : 0
        if (this.maxShow < len) {
          group.forEach((item, index) => {
            if (index > this.maxShow - 1 && index < len) {
              item.hidden = !this.fold
            }
          })
          this.collapsible = true
        } else {
          this.collapsible = false
        }
      },

      search() {
        this.$emit('search', JSON.parse(JSON.stringify(this.query)))
      },
      changeSelect(val) {
        this.$emit('changeSelect', JSON.parse(JSON.stringify(this.query)), val)
      },
      reset: function () {
        this.query = this.initQuery()
        this.$emit('reset', JSON.parse(JSON.stringify(this.query)))
      },

      initQuery() {
        let query = {},
          option
        this.searchParams.forEach(function (p) {
          if (p.type === 'select') {
            option = getObject(p.options, 'selected', true)
            query[p.field] = option ? option.id : ''
          } else {
            query[p.field] = null
          }
        })
        return query
      },
      // 重置某项值
      resetItem(key, type) {
        this.query[key] = type
      },

      isDate(type) {
        return type === 'year' || type === 'month' || type === 'date'
      },
      isDateTime(type) {
        return type === 'datetime'
      },
      isStartDate(type) {
        return type === 'startDate'
      },
      isEndDate(type) {
        return type === 'endDate'
      },
      isStr(type) {
        return type === 'input'
      },
      isSel(type) {
        return type === 'select'
      },
      isRadio(type) {
        return type === 'radio'
      },
      isCascader(type) {
        return type === 'cascader'
      },

      // 输入框特殊字符串过滤
      handleFilterSpecialChar(e) {
        e = e.replace(
          /[` ～*~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/g,
          ''
        )
        return e
      },

      // 限制开始时间必须在结束时间之前
      computedStartTime(key) {
        return {
          disabledDate: function (time) {
            if (key) {
              return time.getTime() > new Date(key).getTime()
            }
          }
        }
      },

      // 限制结束时间在开始时间之后
      computedEndTime(key) {
        return {
          disabledDate: function (time) {
            if (key) {
              return time.getTime() < new Date(key).getTime() - 86400000
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-container {
    padding: 15px 10px 0;
    background-color: #ffffff;
    border-radius: 5px;

    .el-form-item--mini, .el-form-item--small {
      &.el-form-item {
        width: 100%;
        margin-bottom: 10px;
      }

      ::v-deep .el-form-item__content {
        width: 100% !important;
      }

      &[hidden] {
        display: none;
      }

      .el-col[hidden] {
        display: none;
      }
    }

    .expandAllSearch {
      display: flex;
      justify-content: center;
      //padding-bottom: 10px;


      div {
        width: 30px;
        background: #ececec;
        border-radius: 10px;
        text-align: center;
        cursor: pointer;
      }

      i {
        //transform: rotateZ(90deg);

      }
    }

    #searchMain {
      //display: flex;
      //flex-wrap: wrap;
      //justify-content: flex-start;
      padding-bottom: 5px;
    }
  }
</style>
